import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function BookIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<path
				d="M10.1662 15.5793C9.09317 14.9597 7.87592 14.6336 6.63683 14.6336C5.39775 14.6336 4.1805 14.9597 3.10742 15.5793V5.3832C4.1805 4.76366 5.39775 4.4375 6.63683 4.4375C7.87592 4.4375 9.09317 4.76366 10.1662 5.3832M10.1662 15.5793C11.2393 14.9597 12.4566 14.6336 13.6957 14.6336C14.9347 14.6336 16.152 14.9597 17.2251 15.5793V5.3832C16.152 4.76366 14.9347 4.4375 13.6957 4.4375C12.4566 4.4375 11.2393 4.76366 10.1662 5.3832M10.1662 15.5793V5.3832"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
}

export default BookIcon;
